import type { NounsPayload } from '@/core/types';

import type { AppDefinition } from '../types';
import { CardFront } from './CardFront';
import { MissRow } from './MissRow';

export const derDieDasApp: AppDefinition<NounsPayload> = {
  id: 'derdiedas',
  display_name: 'Der · Die · Das',
  CardFront,
  MissRow,
};
